import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CursorState {
    from: number,
    to: number,
    hasExited: boolean
}


const initialState: CursorState = {
    from: 0,
    to: 0,
    hasExited: false
}

const cursorSlice = createSlice({
    name: 'cursor',
    initialState,
    reducers: {
        cursorSetPos: (state, action: PayloadAction<{from: number, to: number}>) => {
            state.from = action.payload.from;
            state.to = action.payload.to;
        },
        cursorHasExited: (state, action: PayloadAction<boolean>) => {
            state.hasExited = action.payload;
        } 
    }
})

export const { cursorSetPos, cursorHasExited } = cursorSlice.actions;

export default cursorSlice.reducer;